export interface NutakuPaymentRequest {
    sku: string
    name: string
    price: number
    imageUrl: string
    description?: string
    customData?: string
}

class NutakuBridge {

    isAvailable(): boolean {
        return typeof (window as any).AndroidNutaku !== "undefined"
    }

    createPayment(data: NutakuPaymentRequest) {

        if (!this.isAvailable()) {
            console.warn("Nutaku bridge not available")
            return
        }

        (window as any).AndroidNutaku.createPayment(JSON.stringify(data))
    }

    confirmPendingPayment() {
        (window as any).AndroidNutaku.confirmPendingPayment()
    }

    openPendingPaymentInBrowser() {
        (window as any).AndroidNutaku.openPendingPaymentInBrowser()
    }

}

export default new NutakuBridge()